<template>
  <!-- The column is the card's own, not the caller's: a card with nothing
       behind it has to take its grid cell with it when it goes, or the row is
       left with a hole where a box used to be. -->
  <v-col v-if="count" cols="12" sm="6" md="4" xl="3">
    <v-card>
      <v-toolbar :color="color" theme="dark">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <!-- The number is the whole point of the header: the list below is
             only the first `limit` of it. -->
        <v-chip class="mr-4" size="small" variant="elevated" :color="countColor">{{ count }}</v-chip>
      </v-toolbar>
      <v-list density="compact" class="dashboard-card-list pa-0">
        <template v-for="item in shown" :key="item.id">
          <slot name="item" :item="item" />
        </template>
      </v-list>
      <!-- Two separate things: how many rows were left out, and the page that
           has them all. A card can need one without the other: a card that fits
           entirely still leads somewhere if it has a page. -->
      <v-card-actions v-if="rest || linked" class="py-1 px-4 text-caption">
        <span v-if="rest" class="text-medium-emphasis">+ {{ rest }} muud</span>
        <v-spacer />
        <!-- `to` for a page of this app, `href` for one outside it. The akt
             module is its own SPA, so its cards have to leave by a real link;
             the intra-side cards stay inside the bundle and route instead,
             which would otherwise reload the whole app to show a list. -->
        <router-link v-if="to" :to="to">Vaata kõiki</router-link>
        <a v-else-if="href" :href="href">Vaata kõiki</a>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    // What the server sent back — already short, because the card's fetch asks
    // for `limit` rows rather than the hundred it used to.
    items: { type: Array, default: () => [] },
    // Every matching row, not just the ones fetched. The lists answer it for
    // free (a COUNT of its own, independent of `limit`), and it is the one
    // thing the old dashboard never showed.
    count: { type: Number, default: 0 },
    limit: { type: Number, default: 8 },
    // Where "Vaata kõiki" goes. At most one of the two: `href` leaves this app
    // (the akt module), `to` is a route within it. See the template.
    href: { type: String, default: null },
    to: { type: [String, Object], default: null },
    color: { type: String, default: 'primary' },
    countColor: { type: String, default: 'white' }
  },
  computed: {
    shown () {
      return (this.items || []).slice(0, this.limit)
    },
    rest () {
      return Math.max(0, this.count - this.shown.length)
    },
    linked () {
      return !!(this.to || this.href)
    }
  }
}
</script>

<style>
/* Vuetify draws the same row at two heights: a dense two-line row is 60px in
   Vuetify 2 and a compact one 56px in Vuetify 3, so the Vue 2 and Vue 3 builds
   disagreed about the size of the same card. Pinned here, where every card's
   list goes through, which also makes the six cards line up with each other —
   a one-line row and a two-line row no longer step up and down the column.
   Three classes deep on purpose: Vuetify's own rule is two, and it is loaded
   after this one, so an even match would lose. */
.v-list.dashboard-card-list .v-list-item {
  min-height: 56px;
}
</style>
